import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dataEdit, fetchImageList } from '../../actions/datamanage';
import { MAX_COMMENT_LENGTH, utf8ByteLength, truncateUtf8 } from '../../helpers/stringByteHelpers';

const DataEdit = ({
    relativeIndex,
    dataEdit,
    fetchImageList,
    selectedItem,
    startDate,
    endDate,
    selectedFacility,
    selectedCamera,
    selectedGauge,
    comments,
    fontSizes,
    setComments,
    setFontSizes,
    setLoading,
    isPopup,
    setIsEditModalOpen,  
    setModalMessage,
    updateComments,
    screenType,
    editStatus,
    setRelativeActive,
    setEditStatus,
}) => {
    const dataEditHandler = async () => {
        let form;
        if (isPopup) {
            form = document.getElementById(`dataformpopup0`); 
        } else {
            form = document.getElementById(`dataform${relativeIndex}`); 
        }

        const inputs = form.getElementsByTagName('input');
        let data = {};

        for (let input of inputs) {
            if (input.type === 'hidden' || input.type === 'text') {
                if (input.value !== '') {
                    if (['comment', 'gauge_id', 'device_id', 'get_datetime', 'company_id'].includes(input.name) ||
                        input.name.startsWith('measure_id')
                    ) {
                        data[input.name] = input.value;
                    } else {
                        const parsedValue = parseFloat(input.value);
                        data[input.name] = isNaN(parsedValue) ? 0 : parsedValue;
                    }
                }
            }
        }

        const diffSpans = form.querySelectorAll(`span[id^="dv_"]`);
        diffSpans.forEach((span) => {
            const spanId = span.id;
            const parts = spanId.split('_');
            const cleanKey = `diff_val${parts[parts.length - 1]}`;

            const spanValue = span.textContent.trim();

            if (spanValue === '--') {
                data[cleanKey] = null; 
            } else {
                data[cleanKey] = parseFloat(spanValue);
            }
        });

        const diffSpansPop = form.querySelectorAll(`span[id^="dvpop_"]`);
        diffSpansPop.forEach((span) => {
            const spanId = span.id;
            const parts = spanId.split('_');
            const cleanKey = `diff_val${parts[parts.length - 1]}`;

            const spanValue = span.textContent.trim();

            if (spanValue === '--') {
                data[cleanKey] = null; 
            } else {
                data[cleanKey] = parseFloat(spanValue);
            }
        });

        if (isPopup) {
            const measureInputs = form.querySelectorAll('input[name^="measure_val"]');
            measureInputs.forEach((input, index) => {
                const measureKey = `measure_val${index}`;
                const parsedValue = parseFloat(input.value);
                data[measureKey] = isNaN(parsedValue) ? null : parsedValue;
            });
        }

        let comment;
        comment = form.querySelector('textarea[name="comment"]').value || '';
        if (utf8ByteLength(comment) > MAX_COMMENT_LENGTH) {
            comment = truncateUtf8(comment, MAX_COMMENT_LENGTH);
        }
        data['comment'] = comment;

        if (form.elements['comment_font_size']) {
            data['comment_font_size'] = fontSizes[relativeIndex] || form.elements['comment_font_size']?.defaultValue || '14';
        }
        const checkbox = form.querySelector('input[name="disuse_flg"]');
        const isCheckboxChecked = checkbox && checkbox.checked;
        if (isCheckboxChecked) {
            data['disuse_flg'] = 'on';
        }

        setLoading(true);

        try {
            await dataEdit(data);
            setRelativeActive(relativeIndex);

            if(!isPopup){
                setEditStatus(() => {
                    const newStatus = {};
                    Object.keys(editStatus).forEach((key) => {
                        newStatus[key] = false;
                    });
                    return newStatus;
                });
                
                Object.keys(editStatus).forEach((key) => {
                    const editBtn = document.getElementById(`edit_btn${key}`);
                    const editUpdateBtn = document.getElementById(`edit_update_btn${key}`);
            
                    if (editBtn) {
                        editBtn.style.display = "block";
                    }
                    if (editUpdateBtn) {
                        editUpdateBtn.style.display = "none";
                    }
                    document.querySelectorAll(`.edit_data_lbl${key}`).forEach(element => {
                        element.style.display = "block";
                    });
                    document.querySelectorAll(`.edit_data${key}`).forEach(element => {
                        element.style.display = "none";
                    });
                    document.querySelectorAll(`#edit_comment_lbl${key}`).forEach(element => {
                        element.style.display = "block";
                    });
                    document.querySelectorAll(`#edit_comment${key}`).forEach(element => {
                        element.style.display = "none";
                    });
                    const editCommentLbl = document.getElementById(`edit_comment_lbl${key}`);
                    const editComment = document.getElementById(`edit_comment${key}`);
                    const sizeEdit = document.getElementById(`size_edit${key}`);
                    const leftLabel = document.getElementById(`leftLabel${key}`);
                    const rightLabel = document.getElementById(`rightLabel${key}`);
            
                    if (editCommentLbl) {
                        editCommentLbl.style.display = "block";
                    }
                    if (editComment) {
                        editComment.style.display = "none";
                    }
                    if (sizeEdit) {
                        sizeEdit.style.display = "none";
                    }
                    if (leftLabel) {
                        leftLabel.style.display = "none";
                    }
                    if (rightLabel) {
                        rightLabel.style.display = "none";
                    }
        
                    const checkbox = document.getElementById(`disuse_flg${key}`);
                    if (checkbox) {
                        checkbox.disabled = true;
                    }
                });
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            id={`edit_update_btn${relativeIndex}`}
            className={`mod-btn__round small ${screenType}`}
            style={isPopup ? {
                display: 'block',
                width: '45%', 
                float: 'right', 
                marginLeft: '10px',  
            } : {
                display: 'none'
            }}
            onClick={dataEditHandler}
        >
            登録
        </button>
    );
};

DataEdit.propTypes = {
    relativeIndex: PropTypes.number.isRequired,
    dataEdit: PropTypes.func.isRequired,
    fetchImageList: PropTypes.func.isRequired,
    selectedItem: PropTypes.object.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    selectedFacility: PropTypes.string.isRequired,
    selectedCamera: PropTypes.string.isRequired,
    selectedGauge: PropTypes.string.isRequired,
    comments: PropTypes.object.isRequired,
    fontSizes: PropTypes.object.isRequired,
    setComments: PropTypes.func.isRequired,
    setFontSizes: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    isPopup: PropTypes.bool,
    setIsEditModalOpen: PropTypes.func, 
    setModalMessage: PropTypes.func, 
};

const mapDispatchToProps = {
    dataEdit,
    fetchImageList
};

export default connect(null, mapDispatchToProps)(DataEdit);
